import { getApplicationId, getUpdatedApplicationDetails, isFromAndroidWebview, MfCentralFlow, nextStepCredStepper } from '../../../configs/utils';
import SharedPropsService from '../../../SharedPropsService';
import { CreditApplicationType, getAppHeader } from '../../../configs/config';
import { ROUTE } from "../../../routes";
import { api } from "../../../configs/api";
import AsyncStorage from "@react-native-async-storage/async-storage";
export const Go_Next_Action = async (action, _datastore, { navigate, network, setDatastore, instrumentTrack }) => {
    await setDatastore(action.routeId, 'kycCard', {
        loading: true,
    });
    instrumentTrack('APPLICATION_START_BUTTON_CLICKED');
    let applicationId;
    let user = await SharedPropsService.getUser();
    const lenderId = user.linkedApplications[0].lenderAccountId;
    if (await AsyncStorage.getItem("application_id") !== null) {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        applicationId = user.linkedApplications[0].applicationId;
    }
    const userApplication = await network.get(`${api.borrowerApplication}${applicationId}`, { headers: await getAppHeader() }).then(response => response.data);
    await setDatastore(action.routeId, 'kycCard', {
        loading: false,
    });
    if (userApplication.currentStepId === "REVIEW_KFS" || userApplication.currentStepId === "AGREEMENT_SIGN" || userApplication.currentStepId === "CREDIT_APPROVAL") {
        lenderId === "Bajaj" ? navigate(ROUTE.BAJAJ_AGREEMENT_STEPPER) : navigate(ROUTE.LOAN_AGREEMENT);
    }
    else {
        const routeObj = await nextStepCredStepper(userApplication.currentStepId);
        await navigate(routeObj.routeId, routeObj.params);
    }
};
export const needHelp = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.CONTACT_US_CARD);
};
export const goBack = async (action, _datastore, { navigateWithClear, network }) => {
    let user;
    if (await SharedPropsService.getUser() !== undefined) {
        user = await SharedPropsService.getUser();
    }
    else {
        const userContextResponse = await network.post(api.userContext, {}, { headers: await getAppHeader() });
        user = userContextResponse?.data;
    }
    const applicationId = await getApplicationId();
    const applicationDetail = await getUpdatedApplicationDetails();
    const applicationType = applicationDetail?.applicationType;
    if (applicationType === CreditApplicationType.CREDIT_RENEWAL_AGAINST_SECURITIES) {
        await navigateWithClear(ROUTE.LOAN_RENEWAL_LANDING_PAGE);
        return;
    }
    if (await AsyncStorage.getItem("application_id") !== null && !(applicationType === CreditApplicationType.CREDIT_AGAINST_SECURITIES_BORROWER)) {
        await navigateWithClear(ROUTE.MANAGE_LIMIT_LANDING);
    }
    else {
        await SharedPropsService.setApplicationState(applicationId);
        if (applicationId === "COMPLETED") {
            await navigateWithClear(ROUTE.DASHBOARD);
        }
        else {
            if (await SharedPropsService.showHome()) {
                const reFetch = true;
                await navigateWithClear(ROUTE.BORROWER_LANDING_SCREEN, { reFetch });
            }
            else {
                window.parent.postMessage("Exit callback", "*");
                // @ts-ignore
                window?.webkit?.messageHandlers?.voltMessageHandler?.postMessage("closeActivity");
                if (isFromAndroidWebview()) {
                    window.open("closeActivity", "_parent");
                }
            }
        }
    }
};
export const continueEditAction = async (action, _datastore, { network, navigateWithClear, setDatastore }) => {
    await setDatastore(ROUTE.KYC_STEPPER, "kycCard", {
        loading: true
    });
    const userData = await SharedPropsService.getUser();
    let applicationId = '';
    if (await AsyncStorage.getItem("application_id") !== null) {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        applicationId = userData.linkedApplications[0].applicationId;
    }
    const enabledRTAFlowResponse = await network.get(`${api.isFromMFCentralFlow}${applicationId}`, { headers: await getAppHeader() });
    const continueEditResponse = await network.get(`${api.editLimitRoute}${applicationId}`, {
        headers: await getAppHeader()
    });
    const isFromMFCentral = enabledRTAFlowResponse?.data?.enabledRtaFlow === MfCentralFlow;
    if (isFromMFCentral) {
        await navigateWithClear(ROUTE.MFC_FETCH_ANCHOR);
    }
    else {
        const currentStepId = continueEditResponse.data.updatedApplicationObj.currentStepId;
        const routeObj = await nextStepCredStepper(currentStepId);
        await navigateWithClear(routeObj.routeId, routeObj.params);
    }
    await setDatastore(ROUTE.KYC_STEPPER, "kycCard", {
        loading: false
    });
};
